import { Resource } from '../types/resource';

export enum App {
  ApiTenant = 'api-tenant',
  ApiLandlord = 'api-landlord',
  AfiniusAuth = 'afinius-auth',
  AfiniusPortal = 'afinius-portal',
  Cityview = 'cityview',
  CityviewOverview = 'cityview-overview',
  Nodr = 'nodr',
  CitizenReport = 'citizen-report',
  SensorRegistry = 'sensor-registry',
}

export interface LandlordApplication extends Resource {
  id: number;
  key: App;
  name: string;
  url: string;
  has_auth: boolean;
  has_tenant_access: boolean;
  has_user_access: boolean;
}
